import { render, staticRenderFns } from "./talentRecommend.vue?vue&type=template&id=5be015c7&scoped=true"
import script from "./talentRecommend.vue?vue&type=script&lang=js"
export * from "./talentRecommend.vue?vue&type=script&lang=js"
import style0 from "./talentRecommend.vue?vue&type=style&index=0&id=5be015c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be015c7",
  null
  
)

export default component.exports